import Error from './models/Error'

export default {

  namespaced: true,

  state: {
    errors: new Error,
    loadingPage: false
  },

  mutations: {
    setErrors: (state, payload) => state.errors = payload,
    clearErrors: (state) => state.errors = new Error,
    loadingPage: (state, value) => state.loadingPage = value
  },

  actions: {

  },

  getters: {
    errors: state => state.errors,
    loadingPage: state => state.loadingPage,
  }

}